import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getActivityList,
	addNewActivity,
	addActivitiesProductiveCycle,
	updateActivity,
	deleteActivity,
	getActivity,
	getActualActivitiesList,

	getActivityGroupList,
	addNewActivityGroup,
	updateActivityGroup,
	deleteActivityGroup,
	getActivityGroup,
	getActivityGroupByCode,

	getActivityPeriodicityList,
	addNewActivityPeriodicity,
	updateActivityPeriodicity,
	deleteActivityPeriodicity,
	getActivityPeriodicity,
	getActivityPeriodicityByCode,

	getActivityPriorityList,
	addNewActivityPriority,
	updateActivityPriority,
	deleteActivityPriority,
	getActivityPriority,
	getActivityPriorityByCode,

	getActivityStatusList,
	addNewActivityStatus,
	updateActivityStatus,
	deleteActivityStatus,
	getActivityStatus,
	getActivityStatusByCode,

	getActivityTemplateList,
	addNewActivityTemplate,
	updateActivityTemplate,
	deleteActivityTemplate,
	getActivityTemplate,
	getActivityTemplateCode,

	getActivityTemplateItemList,
	addNewActivityTemplateItem,
	updateActivityTemplateItem,
	deleteActivityTemplateItem,
	getActivityTemplateItem,

	getActivityTypeList,
	addNewActivityType,
	updateActivityType,
	deleteActivityType,
	getActivityType,
	getActivityTypeByCode,
	updateStatusActivity,
} from '../activity/thunk';

export const initialState = {
	itemActivityList: [],
	itemActivityDetail: null,
	isActivityLoading: false,
	isActivitySuccess: false,
	activityListSelect: [],

	itemActivityGroupList: [],
	itemActivityGroupDetail: null,
	isActivityGroupLoading: false,
	isActivityGroupSuccess: false,
	activityGroupListSelect: [],

	itemActivityPeriodicityList: [],
	itemActivityPeriodicityDetail: null,
	isActivityPeriodicityLoading: false,
	isActivityPeriodicitySuccess: false,
	activityPeriodicityListSelect: [],

	itemActivityPriorityList: [],
	itemActivityPriorityDetail: null,
	isActivityPriorityLoading: false,
	isActivityPrioritySuccess: false,
	activityPriorityListSelect: [],

	itemActivityStatusList: [],
	itemActivityStatusDetail: null,
	isActivityStatusLoading: false,
	isActivityStatusSuccess: false,
	activityStatusListSelect: [],

	itemActivityTemplateList: [],
	itemActivityTemplateDetail: null,
	isActivityTemplateLoading: false,
	isActivityTemplateSuccess: false,
	activityTemplateListSelect: [],

	itemActivityTemplateItemList: [],
	itemActivityTemplateItemDetail: null,
	isActivityTemplateItemLoading: false,
	isActivityTemplateItemSuccess: false,
	activityTemplateItemListSelect: [],

	itemActivityTypeList: [],
	itemActivityTypeDetail: null,
	isActivityTypeLoading: false,
	isActivityTypeSuccess: false,
	activityTypeListSelect: [],
	requireCloseModal: false,

	isReviewing: false,
	isReviewed: false,
	isReviewError: false,

	isStatusUpdating: false,
	isStatusUpdated: false,
	isStatusUpdateError: false,

};

const ActivitySlice = createSlice({
	name: 'Activities',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		cleanItemActivityDetail(state, action){
			state.itemActivityDetail = null;
		}
	},
	extraReducers: builder => {
		builder
			.addCase(getActivityList.pending, state => {
				state.isActivityLoading = true;
				state.error = null;
			})
			.addCase(getActivityList.fulfilled, (state, action) => {
				state.itemActivityList = action.payload;
				state.isActivityLoading = false;
				state.isActivitySuccess = true;

				let activityListSelect = [];
				action.payload.map(item =>
					activityListSelect.push({
						item: item,
						value: item._id,
						label: item.title,
					})
				);
				state.activityListSelect = activityListSelect;
			})
			.addCase(getActivityList.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityLoading = false;
			})

			.addCase(getActivity.fulfilled, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
				state.itemActivityDetail = action.payload;
				state.isLoadingList = false;
			})
			.addCase(getActivity.pending, state => {
				state.isActivityLoading = true;
				state.isActivitySuccess = null;
				state.error = null;
				state.isLoadingList = true;
			})
			.addCase(getActivity.rejected, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;
			})

			

			.addCase(addNewActivity.pending, state => {
				state.isActivityLoading = true;
				state.error = null;
			})
			.addCase(addNewActivity.fulfilled, (state, action) => {
				state.itemActivityList.push(action.payload);
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
			})
			.addCase(addNewActivity.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityLoading = false;
			})
			.addCase(addActivitiesProductiveCycle.pending, state => {
				state.isLoadingList = true;
				state.isAdding = true;
				state.isAdded = false;
				state.isAddError = false;
				state.requireCloseModal = false;

				// Additional
				state.isActivityLoading = true;
				state.error = null;
			})
			.addCase(addActivitiesProductiveCycle.fulfilled, (state, action) => {
				state.isLoadingList = false;
				state.isAdding = false;
				state.isAdded = true;
				state.isAddError = false;
				state.requireCloseModal = true;

				// Additional
				state.itemActivityList.push(action.payload);
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
			})
			.addCase(addActivitiesProductiveCycle.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isLoadingList = false;
				state.isAdding = false;
				state.isAdded = false;
				state.isAddError = true;
				state.requireCloseModal = false;

				// Additional
				state.error = action.payload || null;
				state.isActivityLoading = false;
			})
			.addCase(updateActivity.pending, state => {
				state.isActivityLoading = true;
				state.error = null;
			})
			.addCase(updateActivity.fulfilled, (state, action) => {
				const index = state.itemActivityList.findIndex(
					item => item._id === action.payload._id
				);
				if (index !== -1) {
					state.itemActivityList[index] = action.payload;
				}
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
			})
			.addCase(updateActivity.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityLoading = false;
			})
			.addCase(deleteActivity.pending, state => {
				state.isActivityLoading = true;
				state.error = null;
			})
			.addCase(deleteActivity.fulfilled, (state, action) => {
				state.itemActivityList = current(state.itemActivityList).filter(
					item => item._id !== action.payload._id
				);
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
			})
			.addCase(deleteActivity.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityLoading = false;
			})
			.addCase(getActualActivitiesList.pending, state => {
				state.isActivityLoading = true;
				state.error = null;
			})
			.addCase(getActualActivitiesList.fulfilled, (state, action) => {
				state.itemActivityList = action.payload;
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
			})
			.addCase(getActualActivitiesList.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityLoading = false;
			});


		builder
			.addCase(getActivityGroupList.pending, state => {
				state.isActivityGroupLoading = true;
				state.error = null;
			})
			.addCase(getActivityGroupList.fulfilled, (state, action) => {
				state.itemActivityGroupList = action.payload;
				state.isActivityGroupLoading = false;
				state.isActivityGroupSuccess = true;

				let activityGroupListSelect = [];
				action.payload.map(item =>
					activityGroupListSelect.push({
						item: item,
						value: item._id,
						label: item.name,
					})
				);
				state.activityGroupListSelect = activityGroupListSelect;
			})
			.addCase(getActivityGroupList.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityGroupLoading = false;
			})


			

			.addCase(getActivityGroup.fulfilled, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
				state.itemActivityGroupDetail = action.payload;
				state.isLoadingList = false;
			})
			.addCase(getActivityGroup.pending, state => {
				state.isActivityLoading = true;
				state.isActivitySuccess = null;
				state.error = null;
				state.isLoadingList = true;
			})
			.addCase(getActivityGroup.rejected, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;
			})			

			.addCase(getActivityGroupByCode.fulfilled, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
				state.itemActivityGroupDetail = action.payload;
				state.isLoadingList = false;
			})
			.addCase(getActivityGroupByCode.pending, state => {
				state.isActivityLoading = true;
				state.isActivitySuccess = null;
				state.error = null;
				state.isLoadingList = true;
			})
			.addCase(getActivityGroupByCode.rejected, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;
			})



			.addCase(addNewActivityGroup.pending, state => {
				state.isActivityGroupLoading = true;
				state.error = null;
			})
			.addCase(addNewActivityGroup.fulfilled, (state, action) => {
				state.itemActivityGroupList.push(action.payload);
				state.isActivityGroupLoading = false;
				state.isActivityGroupSuccess = true;
			})
			.addCase(addNewActivityGroup.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityGroupLoading = false;
			})
			.addCase(updateActivityGroup.pending, state => {
				state.isActivityGroupLoading = true;
				state.error = null;
			})
			.addCase(updateActivityGroup.fulfilled, (state, action) => {
				const index = state.itemActivityGroupList.findIndex(
					item => item._id === action.payload._id
				);
				if (index !== -1) {
					state.itemActivityGroupList[index] = action.payload;
				}
				state.isActivityGroupLoading = false;
				state.isActivityGroupSuccess = true;
			})
			.addCase(updateActivityGroup.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityGroupLoading = false;
			})
			.addCase(deleteActivityGroup.pending, state => {
				state.isActivityGroupLoading = true;
				state.error = null;
			})
			.addCase(deleteActivityGroup.fulfilled, (state, action) => {
				state.itemActivityGroupList = current(state.itemActivityGroupList).filter(
					item => item._id !== action.payload._id
				);
				state.isActivityGroupLoading = false;
				state.isActivityGroupSuccess = true;
			})
			.addCase(deleteActivityGroup.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityGroupLoading = false;
			});

		builder
			.addCase(getActivityPeriodicityList.pending, state => {
				state.isActivityPeriodicityLoading = true;
				state.error = null;
			})
			.addCase(getActivityPeriodicityList.fulfilled, (state, action) => {
				state.itemActivityPeriodicityList = action.payload;
				state.isActivityPeriodicityLoading = false;
				state.isActivityPeriodicitySuccess = true;

				let activityPeriodicityListSelect = [];
				action.payload.map(item =>
					activityPeriodicityListSelect.push({
						item: item,
						value: item._id,
						label: item.name,
					})
				);
				state.activityPeriodicityListSelect = activityPeriodicityListSelect;
			})
			.addCase(getActivityPeriodicityList.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityPeriodicityLoading = false;
			})

 

			.addCase(getActivityPeriodicity.fulfilled, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
				state.itemActivityPeriodicityDetail = action.payload;
				state.isLoadingList = false;
			})
			.addCase(getActivityPeriodicity.pending, state => {
				state.isActivityLoading = true;
				state.isActivitySuccess = null;
				state.error = null;
				state.isLoadingList = true;
			})
			.addCase(getActivityPeriodicity.rejected, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;
			})			

			.addCase(getActivityPeriodicityByCode.fulfilled, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
				state.itemActivityPeriodicityDetail = action.payload;
				state.isLoadingList = false;
			})
			.addCase(getActivityPeriodicityByCode.pending, state => {
				state.isActivityLoading = true;
				state.isActivitySuccess = null;
				state.error = null;
				state.isLoadingList = true;
			})
			.addCase(getActivityPeriodicityByCode.rejected, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;
			})



			.addCase(addNewActivityPeriodicity.pending, state => {
				state.isActivityPeriodicityLoading = true;
				state.error = null;
			})
			.addCase(addNewActivityPeriodicity.fulfilled, (state, action) => {
				state.itemActivityPeriodicityList.push(action.payload);
				state.isActivityPeriodicityLoading = false;
				state.isActivityPeriodicitySuccess = true;
			})
			.addCase(addNewActivityPeriodicity.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityPeriodicityLoading = false;
			})
			.addCase(updateActivityPeriodicity.pending, state => {
				state.isActivityPeriodicityLoading = true;
				state.error = null;
			})
			.addCase(updateActivityPeriodicity.fulfilled, (state, action) => {
				const index = state.itemActivityPeriodicityList.findIndex(
					item => item._id === action.payload._id
				);
				if (index !== -1) {
					state.itemActivityPeriodicityList[index] = action.payload;
				}
				state.isActivityPeriodicityLoading = false;
				state.isActivityPeriodicitySuccess = true;
			})
			.addCase(updateActivityPeriodicity.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityPeriodicityLoading = false;
			})
			.addCase(deleteActivityPeriodicity.pending, state => {
				state.isActivityPeriodicityLoading = true;
				state.error = null;
			})
			.addCase(deleteActivityPeriodicity.fulfilled, (state, action) => {
				state.itemActivityPeriodicityList = current(state.itemActivityPeriodicityList).filter(
					item => item._id !== action.payload._id
				);
				state.isActivityPeriodicityLoading = false;
				state.isActivityPeriodicitySuccess = true;
			})
			.addCase(deleteActivityPeriodicity.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityPeriodicityLoading = false;
			});

		builder
			.addCase(getActivityPriorityList.pending, state => {
				state.isActivityPriorityLoading = true;
				state.error = null;
			})
			.addCase(getActivityPriorityList.fulfilled, (state, action) => {
				state.itemActivityPriorityList = action.payload;
				state.isActivityPriorityLoading = false;
				state.isActivityPrioritySuccess = true;

				let activityPriorityListSelect = [];
				action.payload.map(item =>
					activityPriorityListSelect.push({
						item: item,
						value: item._id,
						label: item.name,
					})
				);
				state.activityPriorityListSelect = activityPriorityListSelect;
			})
			.addCase(getActivityPriorityList.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityPriorityLoading = false;
			})

 

			.addCase(getActivityPriority.fulfilled, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
				state.itemActivityPriorityDetail = action.payload;
				state.isLoadingList = false;
			})
			.addCase(getActivityPriority.pending, state => {
				state.isActivityLoading = true;
				state.isActivitySuccess = null;
				state.error = null;
				state.isLoadingList = true;
			})
			.addCase(getActivityPriority.rejected, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;
			})			

			.addCase(getActivityPriorityByCode.fulfilled, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
				state.itemActivityPriorityDetail = action.payload;
				state.isLoadingList = false;
			})
			.addCase(getActivityPriorityByCode.pending, state => {
				state.isActivityLoading = true;
				state.isActivitySuccess = null;
				state.error = null;
				state.isLoadingList = true;
			})
			.addCase(getActivityPriorityByCode.rejected, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;
			})



			.addCase(addNewActivityPriority.pending, state => {
				state.isActivityPriorityLoading = true;
				state.error = null;
			})
			.addCase(addNewActivityPriority.fulfilled, (state, action) => {
				state.itemActivityPriorityList.push(action.payload);
				state.isActivityPriorityLoading = false;
				state.isActivityPrioritySuccess = true;
			})
			.addCase(addNewActivityPriority.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityPriorityLoading = false;
			})
			.addCase(updateActivityPriority.pending, state => {
				state.isActivityPriorityLoading = true;
				state.error = null;
			})
			.addCase(updateActivityPriority.fulfilled, (state, action) => {
				const index = state.itemActivityPriorityList.findIndex(
					item => item._id === action.payload._id
				);
				if (index !== -1) {
					state.itemActivityPriorityList[index] = action.payload;
				}
				state.isActivityPriorityLoading = false;
				state.isActivityPrioritySuccess = true;
			})
			.addCase(updateActivityPriority.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityPriorityLoading = false;
			})
			.addCase(deleteActivityPriority.pending, state => {
				state.isActivityPriorityLoading = true;
				state.error = null;
			})
			.addCase(deleteActivityPriority.fulfilled, (state, action) => {
				state.itemActivityPriorityList = current(state.itemActivityPriorityList).filter(
					item => item._id !== action.payload._id
				);
				state.isActivityPriorityLoading = false;
				state.isActivityPrioritySuccess = true;
			})
			.addCase(deleteActivityPriority.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityPriorityLoading = false;
			});

		builder
			.addCase(getActivityStatusList.pending, state => {
				state.isActivityStatusLoading = true;
				state.error = null;
			})
			.addCase(getActivityStatusList.fulfilled, (state, action) => {
				state.itemActivityStatusList = action.payload;
				state.isActivityStatusLoading = false;
				state.isActivityStatusSuccess = true;

				let activityStatusListSelect = [];
				action.payload.map(item =>
					activityStatusListSelect.push({
						item: item,
						value: item._id,
						label: item.name,
					})
				);
				state.activityStatusListSelect = activityStatusListSelect;
			})
			.addCase(getActivityStatusList.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityStatusLoading = false;
			})

 

			.addCase(getActivityStatus.fulfilled, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
				state.itemActivityStatusDetail = action.payload;
				state.isLoadingList = false;
			})
			.addCase(getActivityStatus.pending, state => {
				state.isActivityLoading = true;
				state.isActivitySuccess = null;
				state.error = null;
				state.isLoadingList = true;
			})
			.addCase(getActivityStatus.rejected, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;
			})			

			.addCase(getActivityStatusByCode.fulfilled, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
				state.itemActivityStatusDetail = action.payload;
				state.isLoadingList = false;
			})
			.addCase(getActivityStatusByCode.pending, state => {
				state.isActivityLoading = true;
				state.isActivitySuccess = null;
				state.error = null;
				state.isLoadingList = true;
			})
			.addCase(getActivityStatusByCode.rejected, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;
			})


			.addCase(addNewActivityStatus.pending, state => {
				state.isActivityStatusLoading = true;
				state.error = null;
			})
			.addCase(addNewActivityStatus.fulfilled, (state, action) => {
				state.itemActivityStatusList.push(action.payload);
				state.isActivityStatusLoading = false;
				state.isActivityStatusSuccess = true;
			})
			.addCase(addNewActivityStatus.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityStatusLoading = false;
			})
			.addCase(updateActivityStatus.pending, state => {
				state.isActivityStatusLoading = true;
				state.error = null;
			})
			.addCase(updateActivityStatus.fulfilled, (state, action) => {
				const index = state.itemActivityStatusList.findIndex(
					item => item._id === action.payload._id
				);
				if (index !== -1) {
					state.itemActivityStatusList[index] = action.payload;
				}
				state.isActivityStatusLoading = false;
				state.isActivityStatusSuccess = true;
			})
			.addCase(updateActivityStatus.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityStatusLoading = false;
			})
			.addCase(deleteActivityStatus.pending, state => {
				state.isActivityStatusLoading = true;
				state.error = null;
			})
			.addCase(deleteActivityStatus.fulfilled, (state, action) => {
				state.itemActivityStatusList = current(state.itemActivityStatusList).filter(
					item => item._id !== action.payload._id
				);
				state.isActivityStatusLoading = false;
				state.isActivityStatusSuccess = true;
			})
			.addCase(deleteActivityStatus.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityStatusLoading = false;
			});

		builder
			.addCase(getActivityTemplateList.pending, state => {
				state.isActivityTemplateLoading = true;
				state.error = null;
			})
			.addCase(getActivityTemplateList.fulfilled, (state, action) => {
				state.itemActivityTemplateList = action.payload;
				state.isActivityTemplateLoading = false;
				state.isActivityTemplateSuccess = true;

				let activityTemplateListSelect = [];
				action.payload.map(item =>
					activityTemplateListSelect.push({
						item: item,
						value: item._id,
						label: item.name,
					})
				);
				state.activityTemplateListSelect = activityTemplateListSelect;
			})
			.addCase(getActivityTemplateList.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTemplateLoading = false;
			})


			.addCase(getActivityTemplate.pending, state => {
				state.isActivityTemplateLoading = true;
				state.error = null;
			})
			.addCase(getActivityTemplate.fulfilled, (state, action) => {
				state.itemActivityTemplateDetail = action.payload;
				state.isActivityTemplateLoading = false;
				state.isActivityTemplateSuccess = true;
			})
			.addCase(getActivityTemplate.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTemplateLoading = false;
			})


			.addCase(getActivityTemplateCode.pending, state => {
				state.isActivityTemplateLoading = true;
				state.error = null;
			})
			.addCase(getActivityTemplateCode.fulfilled, (state, action) => {
				state.itemActivityTemplateDetail = action.payload;
				state.isActivityTemplateLoading = false;
				state.isActivityTemplateSuccess = true;
			})
			.addCase(getActivityTemplateCode.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTemplateLoading = false;
			})


			.addCase(addNewActivityTemplate.pending, state => {
				state.isActivityTemplateLoading = true;
				state.error = null;
			})
			.addCase(addNewActivityTemplate.fulfilled, (state, action) => {
				state.itemActivityTemplateList.push(action.payload);
				state.isActivityTemplateLoading = false;
				state.isActivityTemplateSuccess = true;
			})
			.addCase(addNewActivityTemplate.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTemplateLoading = false;
			})
			.addCase(updateActivityTemplate.pending, state => {
				state.isActivityTemplateLoading = true;
				state.error = null;
			})
			.addCase(updateActivityTemplate.fulfilled, (state, action) => {
				const index = state.itemActivityTemplateList.findIndex(
					item => item._id === action.payload._id
				);
				if (index !== -1) {
					state.itemActivityTemplateList[index] = action.payload;
				}
				state.isActivityTemplateLoading = false;
				state.isActivityTemplateSuccess = true;
			})
			.addCase(updateActivityTemplate.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTemplateLoading = false;
			})
			.addCase(deleteActivityTemplate.pending, state => {
				state.isActivityTemplateLoading = true;
				state.error = null;
			})
			.addCase(deleteActivityTemplate.fulfilled, (state, action) => {
				state.itemActivityTemplateList = current(state.itemActivityTemplateList).filter(
					item => item._id !== action.payload._id
				);
				state.isActivityTemplateLoading = false;
				state.isActivityTemplateSuccess = true;
			})
			.addCase(deleteActivityTemplate.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTemplateLoading = false;
			});

		builder
			.addCase(getActivityTemplateItemList.pending, state => {
				state.isActivityTemplateItemLoading = true;
				state.error = null;
			})
			.addCase(getActivityTemplateItemList.fulfilled, (state, action) => {
				state.itemActivityTemplateItemList = action.payload;
				state.isActivityTemplateItemLoading = false;
				state.isActivityTemplateItemSuccess = true;

				let activityTemplateItemListSelect = [];
				action.payload.map(item =>
					activityTemplateItemListSelect.push({
						item: item,
						value: item._id,
						label: item.name,
					})
				);
				state.activityTemplateItemListSelect = activityTemplateItemListSelect;
			})
			.addCase(getActivityTemplateItemList.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTemplateItemLoading = false;
			})
			.addCase(addNewActivityTemplateItem.pending, state => {
				state.isActivityTemplateItemLoading = true;
				state.error = null;
				state.requireCloseModal = false;
			})
			.addCase(addNewActivityTemplateItem.fulfilled, (state, action) => {
				state.itemActivityTemplateItemList.push(action.payload);
				state.isActivityTemplateItemLoading = false;
				state.isActivityTemplateItemSuccess = true;
				state.requireCloseModal = true;
			})
			.addCase(addNewActivityTemplateItem.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTemplateItemLoading = false;
				state.requireCloseModal = false;
			})
			.addCase(updateActivityTemplateItem.pending, state => {
				state.isActivityTemplateItemLoading = true;
				state.error = null;
				state.requireCloseModal = false;
			})
			.addCase(updateActivityTemplateItem.fulfilled, (state, action) => {
				const index = state.itemActivityTemplateItemList.findIndex(
					item => item._id === action.payload._id
				);
				if (index !== -1) {
					state.itemActivityTemplateItemList[index] = action.payload;
				}
				state.isActivityTemplateItemLoading = false;
				state.isActivityTemplateItemSuccess = true;
				state.requireCloseModal = true;
			})
			.addCase(updateActivityTemplateItem.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTemplateItemLoading = false;
				state.requireCloseModal = false;
			})
			.addCase(deleteActivityTemplateItem.pending, state => {
				state.isActivityTemplateItemLoading = true;
				state.error = null;
			})
			.addCase(deleteActivityTemplateItem.fulfilled, (state, action) => {
				state.itemActivityTemplateItemList = current(state.itemActivityTemplateItemList).filter(
					item => item._id !== action.payload._id
				);
				state.isActivityTemplateItemLoading = false;
				state.isActivityTemplateItemSuccess = true;
			})
			.addCase(deleteActivityTemplateItem.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTemplateItemLoading = false;
			});

		builder
			.addCase(getActivityTypeList.pending, state => {
				state.isActivityTypeLoading = true;
				state.error = null;
			})
			.addCase(getActivityTypeList.fulfilled, (state, action) => {
				state.itemActivityTypeList = action.payload;
				state.isActivityTypeLoading = false;
				state.isActivityTypeSuccess = true;

				let activityTypeListSelect = [];
				action.payload.map(item =>
					activityTypeListSelect.push({
						item: item,
						value: item._id,
						label: item.name,
					})
				);
				state.activityTypeListSelect = activityTypeListSelect;
			})
			.addCase(getActivityTypeList.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTypeLoading = false;
			})

			

			.addCase(getActivityType.fulfilled, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
				state.itemActivityTypeDetail = action.payload;
				state.isLoadingList = false;
			})
			.addCase(getActivityType.pending, state => {
				state.isActivityLoading = true;
				state.isActivitySuccess = null;
				state.error = null;
				state.isLoadingList = true;
			})
			.addCase(getActivityType.rejected, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;
			})			

			.addCase(getActivityTypeByCode.fulfilled, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = true;
				state.itemActivityTypeDetail = action.payload;
				state.isLoadingList = false;
			})
			.addCase(getActivityTypeByCode.pending, state => {
				state.isActivityLoading = true;
				state.isActivitySuccess = null;
				state.error = null;
				state.isLoadingList = true;
			})
			.addCase(getActivityTypeByCode.rejected, (state, action) => {
				state.isActivityLoading = false;
				state.isActivitySuccess = false;
				state.error = action.error.message;
				state.isLoadingList = false;
			})


			.addCase(addNewActivityType.pending, state => {
				state.isActivityTypeLoading = true;
				state.error = null;
			})
			.addCase(addNewActivityType.fulfilled, (state, action) => {
				state.itemActivityTypeList.push(action.payload);
				state.isActivityTypeLoading = false;
				state.isActivityTypeSuccess = true;
			})
			.addCase(addNewActivityType.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTypeLoading = false;
			})
			.addCase(updateActivityType.pending, state => {
				state.isActivityTypeLoading = true;
				state.error = null;
			})
			.addCase(updateActivityType.fulfilled, (state, action) => {
				const index = state.itemActivityTypeList.findIndex(
					item => item._id === action.payload._id
				);
				if (index !== -1) {
					state.itemActivityTypeList[index] = action.payload;
				}
				state.isActivityTypeLoading = false;
				state.isActivityTypeSuccess = true;
			})
			.addCase(updateActivityType.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTypeLoading = false;
			})
			.addCase(deleteActivityType.pending, state => {
				state.isActivityTypeLoading = true;
				state.error = null;
			})
			.addCase(deleteActivityType.fulfilled, (state, action) => {
				state.itemActivityTypeList = current(state.itemActivityTypeList).filter(
					item => item._id !== action.payload._id
				);
				state.isActivityTypeLoading = false;
				state.isActivityTypeSuccess = true;
			})
			.addCase(deleteActivityType.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isActivityTypeLoading = false;
			});

			builder.addCase(updateStatusActivity.fulfilled, (state, action) => {
				state.itemActivityDetail = action.payload;
				state.isLoadingList = false;
				state.isStatusUpdating = false;
				state.isStatusUpdated = true;
				state.isStatusUpdateError = false;
				state.requireCloseModal = true;
			});
			builder.addCase(updateStatusActivity.pending, (state, action) => {
				state.isLoadingList = true;
				state.isStatusUpdating = true;
				state.isStatusUpdated = false;
				state.isStatusUpdateError = false;
				state.requireCloseModal = false;
			});
			builder.addCase(updateStatusActivity.rejected, (state, action) => {
				state.error = action.payload || null;
				state.isLoadingList = false;
				state.isStatusUpdating = false;
				state.isStatusUpdated = false;
				state.isStatusUpdateError = true;
				state.requireCloseModal = false;
			});
	},
});

export const {
	setRequireCloseModal,
	cleanItemActivityDetail
} = ActivitySlice.actions;

export default ActivitySlice.reducer;
